<template>
  <section class="container p-0 my-6 text-sp-primary">
    <div v-if="loading" class="fade flex flex-col text-sp-primary border border-white border-opacity-20 rounded-md bg-sp-secondary bg-opacity-70"><Loading /></div>
    <div v-else-if="error">{{ $t("error") }}</div>
    <div v-else>
      <div class="flex justify-center">
        <h1 class="heading inline-block text-2xl text-sp-accent text-center font-bold">
          {{ $t("popularTopics") }}
        </h1>
      </div>
      <div class="category-list grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-14 mt-6">
        <RouterLink
          v-for="item in articles"
          :key="item.id"
          :to="`/category/${item.categoryId}/section/${item.sectionId}/article/${item.id}`"
          @click="logClick(`main.${item.categoryId}/${item.sectionId}/${item.id}`, 'main.promotedArticles')"
          class="flex items-center gap-3 p-4 px-0 hover:text-sp-accent duration-150 ease-in-out"
        >
          <img :src="item.promoted ? magentaIcon : yellowIcon" alt="dot icon" class="w-3 h-3" />
          <p class="leading-tight line-clamp-1">{{ item.title || "Untitled article" }}</p>
          <img src="../assets/icon-arrow.png" alt="arrow icon" class="w-3 ml-auto" />
        </RouterLink>
      </div>
    </div> 
  </section>
</template>

<script>
import { getUserData } from '../modules/collectData.js'
import { useLogger } from '../composables/useLogger'
import { useHelpCenterFetch } from '../composables/useHelpCenterFetch'
import Loading from '../components/Loading.vue'
import yellowIcon from '../assets/icon-dot-yellow.png'
import magentaIcon from '../assets/icon-dot-magenta.png'

export default {
  components: {
    Loading
  },
  setup() {
    const { lang } = getUserData()
    const { logClick } = useLogger()

    const { data: articles, loading, error, load } = useHelpCenterFetch(
      () => `helpcenter/${lang}/promoted-articles`,
      {
        select: (answer) => {
          if (!Array.isArray(answer)) throw new Error('expected array')
          return answer
        }
      }
    )

    load()

    return {
      articles,
      loading,
      error,
      yellowIcon,
      magentaIcon,
      logClick
    }
  }
}
</script>